import { useState } from 'react';
import { FileText, FileSpreadsheet, File as FileIcon, Play, X, Download } from 'lucide-react';
import { velikost } from './prilohy';
import ProhlizecPriloh from './ProhlizecPriloh';

/**
 * Přílohy u věci — fotky a videa jako čtverce s náhledem, ostatní soubory
 * jako karta s názvem a velikostí. Ťuknutí na fotku nebo video otevře
 * prohlížeč přes celou obrazovku (listování, zoom); soubor se stáhne.
 *
 * `onOdebrat` = režim formuláře (křížek u každé přílohy).
 */
export default function PrilohyMrizka({ prilohy = [], isDark, onOdebrat = null, velikostNahledu = 88 }) {
    const [otevrena, setOtevrena] = useState(null);
    if (!prilohy.length) return null;

    const media = prilohy.filter(p => p.je_obrazek || p.je_video);
    const soubory = prilohy.filter(p => !p.je_obrazek && !p.je_video);
    const hrana = isDark ? 'rgba(255,255,255,0.12)' : 'var(--border-default)';

    const krizek = (p) => onOdebrat && (
        <button type="button" onClick={(e) => { e.stopPropagation(); onOdebrat(p); }} aria-label={`Odebrat ${p.nazev}`}
            style={{ position: 'absolute', top: 3, right: 3, width: 24, height: 24, borderRadius: '50%', background: 'rgba(0,0,0,0.62)', color: '#fff', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
            <X size={14} />
        </button>
    );

    const ikonaSouboru = (p) => {
        if (p.mime === 'application/pdf' || p.mime?.includes('word') || p.mime?.startsWith('text/')) return FileText;
        if (p.mime?.includes('sheet') || p.mime?.includes('excel') || p.mime === 'text/csv') return FileSpreadsheet;
        return FileIcon;
    };

    return (
        <div className="flex flex-col gap-2">
            {media.length > 0 && (
                <div className="flex flex-wrap gap-2">
                    {media.map((p, i) => (
                        <div key={p.id} className="relative" style={{ width: velikostNahledu, height: velikostNahledu, flexShrink: 0 }}>
                            <button type="button" onClick={() => setOtevrena(i)} aria-label={`Otevřít ${p.nazev}`}
                                style={{
                                    width: '100%', height: '100%', padding: 0, borderRadius: 10, overflow: 'hidden', cursor: 'zoom-in',
                                    border: `1px solid ${hrana}`, background: isDark ? '#111' : '#eee', display: 'block',
                                }}>
                                {p.je_obrazek
                                    ? <img src={p.nahled_url || p.url} alt={p.nazev} loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                    : (
                                        <span style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1A1A1A', color: '#fff' }}>
                                            <Play size={22} fill="#fff" />
                                        </span>
                                    )}
                            </button>
                            {krizek(p)}
                        </div>
                    ))}
                </div>
            )}

            {soubory.map(p => {
                const Ikona = ikonaSouboru(p);
                return (
                    <div key={p.id} className="relative">
                        <a href={p.stahnout_url} download={p.nazev}
                            className="flex items-center gap-3"
                            style={{
                                minHeight: 52, padding: '8px 12px', paddingRight: onOdebrat ? 40 : 12, borderRadius: 10,
                                border: `1px solid ${hrana}`, textDecoration: 'none', color: 'var(--text-primary)', maxWidth: 420,
                            }}>
                            <Ikona size={22} style={{ color: 'var(--text-secondary)', flexShrink: 0 }} />
                            <span className="flex-1 min-w-0">
                                <span className="block truncate" style={{ fontSize: 13.5, fontWeight: 600 }}>{p.nazev}</span>
                                <span className="block" style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{velikost(p.velikost)}</span>
                            </span>
                            {!onOdebrat && <Download size={16} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />}
                        </a>
                        {onOdebrat && (
                            <span style={{ position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)' }}>
                                <button type="button" onClick={() => onOdebrat(p)} aria-label={`Odebrat ${p.nazev}`}
                                    style={{ width: 28, height: 28, borderRadius: '50%', border: 'none', background: 'transparent', color: 'var(--text-muted)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <X size={16} />
                                </button>
                            </span>
                        )}
                    </div>
                );
            })}

            {otevrena !== null && (
                <ProhlizecPriloh prilohy={media} index={otevrena} onClose={() => setOtevrena(null)} />
            )}
        </div>
    );
}
